<template>
  <div class="drive-benefit">
    <div class="drive-title">
      <div class="main">订阅出行权益介绍</div>
      <div class="desc">权益生效配合报保险，未报保险/未报警/保险拒赔情况下 </div>
      <div class="desc">用户全额承担，其他不予理赔事项详见<span>《汽车订阅租赁合同》</span></div>
    </div>
    <div class="drive-scroll-view">
      <div class="table-container" :style="{height: winHeight}">
        <!-- 固定表头 -->
        <div ref="headerRef" class="fixed-header">
          <div class="table-row">
            <div class="fixed-cell" style="color: #8e9496;">权益项目</div>
            <div class="table-cell fix-title" :class="{bgLevel1: index < 6, bgLevel2: index < 4, bgLevel3: index < 2}" v-for="(item, index) in row" :key="index">
              {{ item.name }}
              <div class="is-recommend" v-if="item.recommend">
                <!-- <span>推荐</span> -->
                <img src="@/static/image/icon_recommend.jpg" alt="">
              </div>
            </div>
          </div>
        </div>
        <!-- 表格主体 -->
        <div ref="bodyRef" @scroll="syncScroll" class="table-body">
          <div v-for="(i, s) in content" :key="s" class="table-row">
            <div class="fixed-cell"  @click="selectLine = s" :class="{selBg: selectLine === s}">{{ i.name }}</div>
            <div class="table-cell" @click="selectLine = s" :class="{selBg: selectLine === s,  bgLevel1: index < 6, bgLevel2: index < 4, bgLevel3: index < 2}" v-for="(item, index) in i.content" :key="index">
              <div class="table-content-main">{{ item.main }}</div>
              <div class="table-content-sub">{{ item.sub }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import './index.scss'

const selectLine = ref(-1)
const headerRef = ref(null)
const bodyRef = ref(null)
const winHeight = (window.innerHeight - 150) + 'px'
const content = ref([
  {
    name: '车辆损失权益',
    content: [
      {
        main: '1500元内自付',
        sub: '不含轮胎轮毂'
      },
      {
        main: '全额赔付',
        sub: '不含轮胎轮毂'
      },
      {
        main: '全额赔付',
        sub: '不含轮胎轮毂'
      },
      {
        main: '全额赔付',
        sub: '含轮胎轮毂'
      },
      {
        main: '全额赔付',
        sub: '含轮胎轮毂'
      }
    ]
  },
  {
    name: '三者损失权益',
    content: [
      {
        main: '50万'
      },
      {
        main: '100万'
      },
      {
        main: '200万'
      },
      {
        main: '200万'
      },
      {
        main: '200万'
      }
    ]
  },
  {
    name: '驾乘人员 \n守护权益',
    content: [
      {
        main: '2万'
      },
      {
        main: '2万'
      },
      {
        main: '5万'
      },
      {
        main: '5万'
      },
      {
        main: '5万'
      }
    ]
  },
  {
    name: '车辆加速\n折旧权益',
    content: [
      {
        main: '车损≤3千元免收',
        sub: '3千至3万元按20%收取>3万元按30%收取'
      },
      {
        main: '车损≤3千元免收',
        sub: '3千至3万元按20%收取>3万元按30%收取'
      },
      {
        main: '车损≤1万元免收',
        sub: '1万至3万元按20%收取>3万元按30%收取'
      },
      {
        main: '车损≤3万元免收',
        sub: '>3万元按20%收取'
      },
      {
        main: '车损≤5万元免收',
        sub: '>5万元按20%收取'
      }
    ]
  },
  {
    name: '保险上浮权益',
    content: [
      {
        main: '按实际收取',
        sub: ''
      },
      {
        main: '按实际收取',
        sub: ''
      },
      {
        main: '免保险上浮',
        sub: ''
      },
      {
        main: '免保险上浮',
        sub: ''
      },
      {
        main: '免保险上浮',
        sub: ''
      },
    ]
  },
  {
    name: '车辆逾期\n占用损失权益',
    content: [
      {
        main: '按100%收取',
        sub: ''
      },
      {
        main: '按100%收取',
        sub: ''
      },
      {
        main: '按70%收取',
        sub: ''
      },
      {
        main: '占用费用≤1万元免收',
        sub: '>1万元按50%收取'
      },
      {
        main: '占用费用≤3万元免收',
        sub: '>3万元按50%收取'
      },
    ]
  },
  {
    name: '行无忧权益',
    subName: '免处理不计分\n交通违章服务费',
    content: [
      {
        main: '按实际收取'
      },
      {
        main: '按实际收取'
      },
      {
        main: '免服务费'
      },
      {
        main: '免服务费'
      },
      {
        main: '免服务费'
      }
    ]
  },
  {
    name: '还车充电\n服务权益',
    content: [
      {
        main: '还车电量<50%需支付充电服务费',
        sub: ''
      },
      {
        main: '还车电量<50%需支付充电服务费',
        sub: ''
      },
      {
        main: '还车电量<50%免充电服务费',
        sub: ''
      },
      {
        main: '还车电量<50%免充电服务费',
        sub: ''
      },
      {
        main: '还车电量<50%免充电服务费',
        sub: ''
      },
    ]
  },
  {
    name: '收费上限',
    content: [
      {
        main: '免费提供'
      },
      {
        main: '每30天按15天收取'
      },
      {
        main: '每30天按15天收取'
      },
      {
        main: '每30天按15天收取'
      },
      {
        main: '每30天按15天收取'
      }
    ]
  },
  {
    name: '收费标准',
    content: [
      {
        main: '免费提供'
      },
      {
        main: '40元/天'
      },
      {
        main: '60元/天'
      },
      {
        main: '120元/天'
      },
      {
        main: '150元/天'
      }
    ]
  }
])
const row = ref([
  {
    name: '基础出行服务',
    recommend: false
  },
  {
    name: '安心出行服务',
    recommend: false
  },
  {
    name: '优享出行服务',
    recommend: true
  },
  {
    name: '尊享出行服务',
    recommend: true
  },
  {
    name: '无忧出行服务',
    recommend: false
  }
])
const syncScroll = () => {
  if (headerRef.value && bodyRef.value) {
    headerRef.value.scrollLeft = bodyRef.value.scrollLeft
  }
}
</script>
